import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type { GetOversightAssessmentResultCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentResultCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

export const useGetOversightAssessmentResultCount = createQueryHook<
  NavigationCountArgs,
  NavigationCounts,
  GetOversightAssessmentResultCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  // Map each per-table count back onto its GraphQL aggregate root. ConnectedCount
  // sums the four; a null count (that group's query failed) becomes a null
  // aggregate so the badge blanks rather than reading as 0.
  mapTrpcDataToGraphQL: (data) => ({
    risk_controlled_oversight_result_aggregate: {
      aggregate: toAggregate(
        data.oversightAssessmentResult.risk_controlled_second_line_result
      ),
    },
    risk_uncontrolled_oversight_result_aggregate: {
      aggregate: toAggregate(
        data.oversightAssessmentResult.risk_uncontrolled_second_line_result
      ),
    },
    document_oversight_result_aggregate: {
      aggregate: toAggregate(
        data.oversightAssessmentResult.document_second_line_result
      ),
    },
    obligation_oversight_result_aggregate: {
      aggregate: toAggregate(
        data.oversightAssessmentResult.obligation_second_line_result
      ),
    },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetOversightAssessmentResultCountDocument,
});
